/*
 * @Author: edvardchen
 * @Date:   2017-03-07 16:23:17
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:36:47
 */

// @flow
import React from 'react';

import styles from './index.scss';

import Label from './LabelForShare';
import Image from '../Image';

const MULTI_IMAGE_INDICATOR = 3;

const MULTI_IMAGE_PADDING = '25%';

const SINGLE_IMAGE_PADDING = '75%';

const renderLabels = (labels = []) => {
  if (!labels.length) {
    return null;
  }
  return (
    <div className={styles.tagLine}>
      {labels.map((item) => (
        <Label {...item} key={item.text} />
      ))}
    </div>
  );
};

type Props = {
  thumbs?: string[],
  title: string,
  labels?: Array<*>,
};

export default function FeedItem({ thumbs = [], title, labels = [], ...rest }: Props) {
  if (thumbs.length < MULTI_IMAGE_INDICATOR) {
    return (
      <div className={styles.singleImageContainer} {...rest}>
        <div className={styles.main}>
          <h2 className={styles.title}>{title}</h2>
          {renderLabels(labels)}
        </div>
        {thumbs[0] && (
          <div className={styles.right}>
            <Image src={thumbs[0]} initPadding={SINGLE_IMAGE_PADDING} />
          </div>
        )}
      </div>
    );
  }
  return (
    <div {...rest}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.imgList}>
        {thumbs.slice(0, MULTI_IMAGE_INDICATOR).map((src, index) => (
          <Image src={src} key={index} initPadding={MULTI_IMAGE_PADDING} className={styles.imgItem} />
        ))}
      </div>
      {renderLabels(labels)}
    </div>
  );
}
